var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBayView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 19,
    viewBox: "0 0 16 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.2146 6.85097H12.965M8.26338 0.429688V2.07585V11.5526M8.26338 0.973904C10.8599 0.973904 12.965 3.07907 12.965 5.67556V11.5526H8.26338C8.26338 11.5526 8.26338 2.81049 8.26338 0.973904Z",
    stroke: "#3C3C3C",
    strokeWidth: 1.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.31226 6.85097H3.56182M8.26348 0.429688V2.07585V11.5526M8.26348 0.973904C5.66699 0.973904 3.56182 3.07907 3.56182 5.67556V11.5526H8.26348C8.26348 11.5526 8.26348 2.81049 8.26348 0.973904Z",
    stroke: "#3C3C3C",
    strokeWidth: 1.3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1404 11.5522V17.4293",
    stroke: "#3C3C3C",
    strokeWidth: 1.3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7896 11.5522V17.4293",
    stroke: "#3C3C3C",
    strokeWidth: 1.3
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.43872 11.5522V17.4293",
    stroke: "#3C3C3C",
    strokeWidth: 1.3
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.08813 11.5522V17.4293",
    stroke: "#3C3C3C",
    strokeWidth: 1.3
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M4.7373 11.5522V17.4293",
    stroke: "#3C3C3C",
    strokeWidth: 1.3
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M2.38647 11.5522V17.4293",
    stroke: "#3C3C3C",
    strokeWidth: 1.3
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M0.623291 17.4292H15.9037",
    stroke: "#3C3C3C",
    strokeWidth: 1.3
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M0.623291 11.5525H15.9037",
    stroke: "#3C3C3C",
    strokeWidth: 1.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBayView);
export default __webpack_public_path__ + "static/media/bay-view.0cd13dea8290e6ba27b48f8df85779b5.svg";
export { ForwardRef as ReactComponent };